export default __webpack_public_path__ + "static/media/RTR1604V_Posterior.6c4b8838.webp";